import { createColumn, createCheckboxColumn } from "../components/Table/Table";

export const userColumns: State.Column[] = [
  createColumn("Account", (user: Api.User) => user.adAccount, "user.adAccount", true),
  createCheckboxColumn(
    "read",
    (user: Api.User) => (user.roles.find(role => role.name === "read") ? true : false),
    "",
    true
  ),
  createCheckboxColumn(
    "faultviewer-basic",
    (user: Api.User) => (user.roles.find(role => role.name === "faultviewer-basic") ? true : false),
    "",
    true
  ),
  createCheckboxColumn(
    "lift-write",
    (user: Api.User) => (user.roles.find(role => role.name === "lift-write") ? true : false),
    "",
    true
  ),
  createCheckboxColumn(
    "drive-write",
    (user: Api.User) => (user.roles.find(role => role.name === "drive-write") ? true : false),
    "",
    true
  ),
  createCheckboxColumn(
    "group-write",
    (user: Api.User) => (user.roles.find(role => role.name === "group-write") ? true : false),
    "",
    true
  ),
  createCheckboxColumn(
    "lio-write",
    (user: Api.User) => (user.roles.find(role => role.name === "lio-write") ? true : false),
    "",
    true
  ),
  createCheckboxColumn(
    "apm-write",
    (user: Api.User) => (user.roles.find(role => role.name === "apm-write") ? true : false),
    "",
    true
  ),
  createCheckboxColumn(
    "safety-write",
    (user: Api.User) => (user.roles.find(role => role.name === "safety-write") ? true : false),
    "",
    true
  ),
  createCheckboxColumn(
    "signalization-write",
    (user: Api.User) => (user.roles.find(role => role.name === "signalization-write") ? true : false),
    "",
    true
  ),
  createCheckboxColumn(
    "network-write",
    (user: Api.User) => (user.roles.find(role => role.name === "network-write") ? true : false),
    "",
    true
  ),
  createCheckboxColumn(
    "monitoring-write",
    (user: Api.User) => (user.roles.find(role => role.name === "monitoring-write") ? true : false),
    "",
    true
  ),
  createCheckboxColumn(
    "site-write",
    (user: Api.User) => (user.roles.find(role => role.name === "site-write") ? true : false),
    "",
    true
  ),
  createCheckboxColumn(
    "translation",
    (user: Api.User) => (user.roles.find(role => role.name === "translation") ? true : false),
    "",
    true
  ),
  createCheckboxColumn(
    "admin",
    (user: Api.User) => (user.roles.find(role => role.name === "admin") ? true : false),
    "",
    true
  ),
  createCheckboxColumn(
    "license-generation",
    (user: Api.User) =>
      user.roles.find(role => role.name === "license-generation") ? true : false,
    "",
    true
  ),
  createCheckboxColumn(
    "nonkone-write",
    (user: Api.User) => (user.roles.find(role => role.name === "nonkone-write") ? true : false),
    "",
    true
  ),
  createCheckboxColumn(
    "escalator-write",
    (user: Api.User) => (user.roles.find(role => role.name === "escalator-write") ? true : false),
    "",
    true
  ),
  createCheckboxColumn(
    "door-write",
    (user: Api.User) => (user.roles.find(role => role.name === "door-write") ? true : false),
    "",
    true
  ),
  createCheckboxColumn(
    "write",
    (user: Api.User) => (user.roles.find(role => role.name === "write") ? true : false),
    "",
    true
  ),
  createCheckboxColumn(
    "unknown-write",
    (user: Api.User) => (user.roles.find(role => role.name === "unknown-write") ? true : false),
    "",
    true
  ),
  createColumn("Created By", (user: Api.User) => user.createdBy, "user.createdBy", false),
  createColumn("Created Date", (user: Api.User) => user.createdDate, "user.createdDate", false),
  createColumn("Modified By", (user: Api.User) => user.modifiedBy, "user.modifiedBy", false),
  createColumn("Modified Date", (user: Api.User) => user.modifiedDate, "user.modifiedDate", false)
];

export const AADGroupColumns: State.Column[] = [
  createColumn("AAD Group Name", (aadGroup: Api.AADGroup) => aadGroup.name, "aadGroup.name", true),
  createCheckboxColumn(
    "read",
    (aadGroup: Api.AADGroup) => (aadGroup.roles.find(role => role.name === "read") ? true : false),
    "",
    true
  ),
  createCheckboxColumn(
    "faultviewer-basic",
    (aadGroup: Api.AADGroup) =>
      aadGroup.roles.find(role => role.name === "faultviewer-basic") ? true : false,
    "",
    true
  ),
  createCheckboxColumn(
    "lift-write",
    (aadGroup: Api.AADGroup) =>
      aadGroup.roles.find(role => role.name === "lift-write") ? true : false,
    "",
    true
  ),
  createCheckboxColumn(
    "drive-write",
    (aadGroup: Api.AADGroup) =>
      aadGroup.roles.find(role => role.name === "drive-write") ? true : false,
    "",
    true
  ),
  createCheckboxColumn(
    "group-write",
    (aadGroup: Api.AADGroup) =>
      aadGroup.roles.find(role => role.name === "group-write") ? true : false,
    "",
    true
  ),
  createCheckboxColumn(
    "lio-write",
    (aadGroup: Api.AADGroup) =>
      aadGroup.roles.find(role => role.name === "lio-write") ? true : false,
    "",
    true
  ),
  createCheckboxColumn(
    "apm-write",
    (aadGroup: Api.AADGroup) =>
      aadGroup.roles.find(role => role.name === "apm-write") ? true : false,
    "",
    true
  ),
  createCheckboxColumn(
    "safety-write",
    (aadGroup: Api.AADGroup) =>
      aadGroup.roles.find(role => role.name === "safety-write") ? true : false,
    "",
    true
  ),
  createCheckboxColumn(
    "signalization-write",
    (aadGroup: Api.AADGroup) =>
      aadGroup.roles.find(role => role.name === "signalization-write") ? true : false,
    "",
    true
  ),
  createCheckboxColumn(
    "network-write",
    (aadGroup: Api.AADGroup) => (aadGroup.roles.find(role => role.name === "network-write") ? true : false),
    "",
    true
  ),
  createCheckboxColumn(
    "monitoring-write",
    (aadGroup: Api.AADGroup) => (aadGroup.roles.find(role => role.name === "monitoring-write") ? true : false),
    "",
    true
  ),
  createCheckboxColumn(
    "site-write",
    (aadGroup: Api.AADGroup) =>
      aadGroup.roles.find(role => role.name === "site-write") ? true : false,
    "",
    true
  ),
  createCheckboxColumn(
    "translation",
    (aadGroup: Api.User) =>
      aadGroup.roles.find(role => role.name === "translation") ? true : false,
    "",
    true
  ),
  createCheckboxColumn(
    "admin",
    (aadGroup: Api.AADGroup) => (aadGroup.roles.find(role => role.name === "admin") ? true : false),
    "",
    true
  ),
  createCheckboxColumn(
    "license-generation",
    (aadGroup: Api.AADGroup) =>
      aadGroup.roles.find(role => role.name === "license-generation") ? true : false,
    "",
    true
  ),
  createCheckboxColumn(
    "nonkone-write",
    (aadGroup: Api.AADGroup) =>
      aadGroup.roles.find(role => role.name === "nonkone-write") ? true : false,
    "",
    true
  ),
  createCheckboxColumn(
    "escalator-write",
    (aadGroup: Api.AADGroup) =>
      aadGroup.roles.find(role => role.name === "escalator-write") ? true : false,
    "",
    true
  ),
  createCheckboxColumn(
    "door-write",
    (aadGroup: Api.AADGroup) =>
      aadGroup.roles.find(role => role.name === "door-write") ? true : false,
    "",
    true
  ),
  createCheckboxColumn(
    "write",
    (user: Api.User) => (user.roles.find(role => role.name === "write") ? true : false),
    "",
    true
  ),
  createCheckboxColumn(
    "unknown-write",
    (user: Api.User) => (user.roles.find(role => role.name === "unknown-write") ? true : false),
    "",
    true
  ),
  createColumn("Created By", (aadGroup: Api.AADGroup) => aadGroup.createdBy, "aadGroup.createdBy", false),
  createColumn("Created Date", (aadGroup: Api.AADGroup) => aadGroup.createdDate, "aadGroup.createdDate", false),
  createColumn("Modified By", (aadGroup: Api.AADGroup) => aadGroup.modifiedBy, "aadGroup.modifiedBy", false),
  createColumn("Modified Date", (aadGroup: Api.AADGroup) => aadGroup.modifiedDate, "aadGroup.modifiedDate", false)
];
